export default __webpack_public_path__ + "media/fonts/foundation-icons/svgs/fi-trees-35b20ba00ee03f59b03c4e096e20beaf.svg";